export enum NotificationType {
  MEMBER_CONSENT = "member_consent",
  LEFT_FAMILY = "left_family",
  DECLINED_INVITE = "declined_invite",
  DECLINE_PROFILE_ACCESS = "decline_profile_access",
  DELETE_ACCOUNT = "delete_account",
  ACCEPTED_INVITE = "accepted_invite",
  NEW_FO_CONSENT = "new_fo_consent",
  SUBSCRIPTION_ENDING_SOON = "subscription_ending_soon",
  SUBSCRIPTION_PAYMENT_FAILED = "subscription_payment_failed",
  TERMS_CONSENT = "terms_consent",
  FO_DELETED_MEMBER = "fo_deleted_member",
}

export enum NotificationStatus {
  PENDING = "pending",
  READ = "read",
}

export interface Notification {
  id: string;
  type: NotificationType;
  title?: string;
  message: string;
  memberId: string;
  familyId: string;
  status: NotificationStatus;
  createdAt: string;
  updatedAt: string;
}
